import { render, staticRenderFns } from "./documentTypeList.vue?vue&type=template&id=104831e5&scoped=true&"
import script from "./documentTypeList.vue?vue&type=script&lang=js&"
export * from "./documentTypeList.vue?vue&type=script&lang=js&"
import style0 from "./documentTypeList.vue?vue&type=style&index=0&id=104831e5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "104831e5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('104831e5')) {
      api.createRecord('104831e5', component.options)
    } else {
      api.reload('104831e5', component.options)
    }
    module.hot.accept("./documentTypeList.vue?vue&type=template&id=104831e5&scoped=true&", function () {
      api.rerender('104831e5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customerService/documentTypeList.vue"
export default component.exports